export const MediaQueries = {
  mobileMinwidth: '320px',
  mobileMaxwidth: '480px',
  tabletMinwidth: '481px',
  tabletMaxwidth: '768px',
  desktopMinwidth: '992px',
  desktopMaxwidth: '1200px',
};
